<template>
  <div class="content">
    <div class="control_bar top">
      <div class="search">
        {{ title }}
      </div>
    </div>

    <div class="content_main">
      <div class="margin_bottom">{{ infoLabel }}</div>

      <div class="flex margin_bottom">
        <div>
          <div>{{ startLabel }}</div>
          <datepicker
            placeholder="Select Date"
            :config="start_config"
            :locale="ja"
            id="start"
            :value="maintenance.startDateTime"
            @on-change="customFormatter"
            class="start_datepicker start_date_time"
          >
          </datepicker>
        </div>
        <span style="margin: 20px 20px 10px 10px">～</span>
        <div>
          <div>{{ endLabel }}</div>
          <datepicker
            placeholder="Select Date"
            :config="end_config"
            :locale="ja"
            id="end"
            :value="maintenance.endDateTime"
            @on-change="customFormatter"
            class="end_datepicker end_date_time"
          >
          </datepicker>
        </div>
      </div>

      <div>{{ maintenanceMessageLabel }}</div>
      <textarea
        id="maintenance_message"
        class="detail_input_field margin_bottom"
        v-model="maintenance.message"
      />

      <div>{{ tenantSelectLabel }}</div>
      <div class="flex margin_bottom_s">
        <input
          id="searchWord"
          class="detail_input_field tenant_searchbox"
          type="text"
          :placeholder="searchPlaceholder"
        />
        <input
          type="button"
          :value="searchButton"
          class="finish_button"
          @click="searchCorporations(0)"
        />
      </div>
      <div class="flex selec_bottom">
        <input
          type="checkbox"
          class="checkbox"
          v-model="maintenance.allFlag"
          @click="selectAllAction"
        />
        <div>{{ selectAllLabel }}</div>
      </div>

      <div class="table_area">
        <table class="content_title" rules="rows">
          <tr class="items_table">
            <th class="table_checkbox">
              <input
                type="checkbox"
                class="checkbox"
                :checked="checked"
                :disabled="disabled"
                @click="allCheckedAction"
              />
            </th>
            <td class="table_contents">
              <label>{{ corporationNameLabel }}</label>
            </td>
            <td class="table_contents">
              <label>{{ tenantIdLabel }}</label>
            </td>
            <td class="table_contents">
              <label>{{ tenantNameLabel }}</label>
            </td>
          </tr>
        </table>

        <table class="items_table" rules="rows">
          <!-- メンテ中のテナントはグレーアウト -->
          <tr
            class="item_table_row"
            :class="{
              table_row_disabled:
                new Date(maintenance.startDateTime) <= new Date() &&
                new Date(maintenance.endDateTime) > new Date() &&
                previousSelectedTenantList.find(
                  prevSelectedTenant =>
                    prevSelectedTenant.companyId === tenant.companyId
                )
            }"
            v-for="tenant in corporations"
            :key="tenant.companyId"
          >
            <th class="table_checkbox">
              <input
                type="checkbox"
                class="checkbox"
                v-model="tenant.checked"
                :disabled="disabled"
                @click="checkedAction(tenant)"
              />
            </th>
            <td class="table_contents">
              <label>{{ tenant.corporationName }}</label>
            </td>
            <td class="table_contents">
              <label>{{ tenant.companyId }}</label>
            </td>
            <td class="table_contents">
              <label>{{ tenant.companyName }}</label>
            </td>
          </tr>
        </table>
      </div>
      <div class="bottom">
        <pagination
          v-model="page"
          :records="total"
          :per-page="pageSize"
          :options="{texts: {count: '{from} - {to}/{count}件'}, chunk: 5}"
          @paginate="setCorporations(page - 1)"
        >
        </pagination>
      </div>
      <div class="bottom_button_area">
        <input
          type="button"
          :value="cancelButton"
          class="cancel_button"
          @click="cancel"
        />
        <input
          type="button"
          :value="confirmButton"
          class="finish_button"
          @click="checkInput"
        />
      </div>
    </div>
    <div class="complete_modal_window" v-if="showFailureModal">
      <completeModalWindow :question="failureWord" @close="close">
      </completeModalWindow>
    </div>
    <div class="loading_modal_window" v-if="showloadingModal">
      <loadingModalWindow @close="close"> </loadingModalWindow>
    </div>
  </div>
</template>

<script>
import Pagination from 'vue-pagination-2'
import datepicker from 'vue-flatpickr-component'
import japanese from 'flatpickr/dist/l10n/ja.js'
import loadingModalWindow from '../../../modalWindow/loadingModalWindow.vue'
import completeModalWindow from '../modalWindow/finishModalWindow.vue'

export default {
  data() {
    return {
      title: 'メンテナンス予定編集',
      infoLabel: 'メンテナンス予定日時',
      startLabel: '開始',
      endLabel: '終了',
      maintenanceMessageLabel: 'メンテナンス画面表示メッセージ',
      tenantSelectLabel: 'メンテナンス実施テナント選択',
      searchPlaceholder: '法人名/テナントID/テナント名',
      searchButton: '検索',
      selectAllLabel:
        '全体通知 ※個別のチェックに関係なく全体に通知します。後から作成されたテナントにも通知されます。',
      corporationNameLabel: '法人名',
      tenantIdLabel: 'テナントID',
      tenantNameLabel: 'テナント名',
      cancelButton: 'キャンセル',
      confirmButton: '確認',
      failureWord: '',
      disabled: false,
      showFailureModal: false,
      showloadingModal: false,
      toBackList: true,
      checked: false,
      ja: japanese,
      start_config: {
        dateFormat: 'Y/m/d H:i',
        locale: japanese,
        enableTime: true,
        time_24hr: true,
        defaultDate: new Date().setDate(new Date().getDate() - 7),
        minuteIncrement: 1,
        maxDate: '9999'
      },
      end_config: {
        dateFormat: 'Y/m/d H:i',
        locale: japanese,
        enableTime: true,
        time_24hr: true,
        defaultDate: new Date(),
        minuteIncrement: 1,
        maxDate: '9999'
      },
      pageSize: 20,
      page: 1,
      prevTotal: 0,
      searchWord: null,
      selectAll: false
    }
  },
  computed: {
    sysErrorMsg() {
      return this.$store.state.error.sysErrorMsg
    },
    selectedTenantList() {
      return this.$store.state.maintenance.selectedTenantList
    },
    previousSelectedTenantList() {
      return this.$store.state.maintenance.previousSelectedList
    },
    corporations() {
      let corporations = this.$store.state.corporations.corporations
      for (var i = 0; i < corporations.length; i++) {
        if (
          this.selectedTenantList.some(
            selectedTenant =>
              selectedTenant.companyId === corporations[i].companyId
          )
        ) {
          corporations[i].checked = true
        }
      }
      return corporations
    },
    total() {
      if (
        (this.page - 1) * this.pageSize <=
        this.$store.state.corporations.total
      ) {
        return this.$store.state.corporations.total
      }
      return this.prevTotal
    },
    isOverPage() {
      return (
        (this.page - 1) * this.pageSize >= this.$store.state.corporations.total
      )
    },
    lastPage() {
      const last = Math.ceil(
        this.$store.state.corporations.total / this.pageSize
      )
      return last === 0 ? 1 : last
    },
    maintenance() {
      // maintenanceは通信で取得した現在のデータ
      // inputDataは編集したデータ（確認ボタン押下時に保存される）
      // 確認画面から戻ってきた際、inputDataにデータがあればそちらを表示する
      var maintenance = this.$store.state.maintenance.maintenance
      var inputData = this.$store.state.maintenance.updateData
      if (inputData.message) {
        maintenance.message = inputData.message
      }
      if (inputData.startDateTime) {
        maintenance.startDateTime = inputData.startDateTime
      }
      if (inputData.endDateTime) {
        maintenance.endDateTime = inputData.endDateTime
      }
      return maintenance
    },
    inputData() {
      return this.$store.state.maintenance.updateData
    }
  },
  components: {
    Pagination,
    datepicker,
    completeModalWindow,
    loadingModalWindow
  },
  async created() {
    window.addEventListener('resize', this.handleResize)
    this.updateWindowHeight()
    this.showloadingModal = true
    if (!this.$store.state.maintenance.isCancel) {
      try {
        await this.$store.dispatch('maintenance/setMaintenanceDetail', {
          maintenanceId: this.inputData.maintenanceId
        })
        this.setCorporations(0)
        this.toBackList = false
      } catch (error) {
        let eventNumber = this.$store.state.error.sysErrorCode
          .sysErrorCode_650005
        this.createErrorMessage(error, eventNumber, 'MSGCRD0114')
        this.showFailureModal = true
      }
    }
    this.$store.state.maintenance.isCancel = false
    if (this.maintenance.allFlag === true) {
      this.selectAllAction()
    }
    this.showloadingModal = false
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      // ウィンドウサイズ変更時にリアルタイムでウィンドウサイズの値を更新
      this.updateWindowHeight()
    },
    updateWindowHeight() {
      this.windowHeight = window.innerHeight
    },
    searchCorporations(pageNo) {
      this.searchWord = document.getElementById('searchWord').value
      this.setCorporations(pageNo)
    },
    async setCorporations(pageNo) {
      this.showloadingModal = true
      let focus = document.activeElement
      focus.blur()
      try {
        await this.$store.dispatch('corporations/setCorporations', {
          pageNo: pageNo,
          searchWord: this.searchWord
        })
        if (this.isOverPage) {
          this.page = this.lastPage
        } else {
          this.page = pageNo + 1
        }
      } catch (error) {
        let eventNumber = this.$store.state.error.sysErrorCode
          .sysErrorCode_140001
        this.createErrorMessage(error, eventNumber, 'MSGCRD0045')
        this.showFailureModal = true
      }
      this.showloadingModal = false
      this.checked = false
    },
    customFormatter(e) {
      let date = new Date(e)
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var day = date.getDate()
      var hours = date.getHours()
      var minutes = date.getMinutes()
      return year + '/' + month + '/' + day + ' ' + hours + ':' + minutes
    },
    async cancel(e) {
      this.$store.dispatch('maintenance/clearUpdateData')
      this.$store.dispatch('maintenance/clearSelectedTenantList')
      this.$router.push('/master/maintenance')
    },
    selectAllAction(e) {
      // 全体通知用チェック、リストのグレーアウト。
      this.disabled = !this.disabled
      for (let i = 0; i < this.corporations.length; i++) {
        this.corporations[i].disabled = this.disabled
      }
      this.$store.dispatch(
        'maintenance/updateSelectedTenantList',
        this.corporations
      )
      if (!this.selectAll) {
        this.selectAll = true
      } else {
        this.selectAll = false
      }
    },
    allCheckedAction(e) {
      // リストのチェックボックスを全てチェックする。
      this.$store.state.maintenance.selectAllFlag = false
      this.checked = !this.checked

      if (
        new Date(this.maintenance.startDateTime) <= new Date() &&
        new Date(this.maintenance.endDateTime) > new Date()
      ) {
        // メンテ中のテナントのチェック状態は変更しない
        for (let i = 0; i < this.corporations.length; i++) {
          if (
            !this.previousSelectedTenantList.find(
              tenant => tenant.companyId === this.corporations[i].companyId
            )
          ) {
            this.corporations[i].checked = this.checked
          }
        }
      } else {
        for (let i = 0; i < this.corporations.length; i++) {
          this.corporations[i].checked = this.checked
        }
      }
      this.$store.dispatch(
        'maintenance/updateSelectedTenantList',
        this.corporations
      )
    },
    checkedAction(tenant) {
      tenant.checked = !tenant.checked
      this.$store.dispatch('maintenance/updateSelectedTenantList', [tenant])
      this.$store.state.maintenance.selectAllFlag = false
    },
    checkInput() {
      // フォーマットチェック
      let message = document.getElementById('maintenance_message').value
      let start = document.getElementById('start').value
      let end = document.getElementById('end').value
      let startDateTime = 0
      let endDateTime = 0
      // 空チェック
      if (start === '') {
        let eventNumber = this.$store.state.error.sysErrorCode
          .sysErrorCode_650003
        let eventType = 9
        let reason = 'MSGCRD0091'
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.failureWord =
          this.sysErrorMsg.MSGCRD0091.name +
          this.sysErrorMsg.MSGCRD0091.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        this.showFailureModal = true
        this.showloadingModal = false
        return
      }
      if (end === '') {
        let eventNumber = this.$store.state.error.sysErrorCode
          .sysErrorCode_650003
        let eventType = 9
        let reason = 'MSGCRD0091'
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.failureWord =
          this.sysErrorMsg.MSGCRD0091.name +
          this.sysErrorMsg.MSGCRD0091.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        this.showFailureModal = true
        this.showloadingModal = false
        return
      }
      let startDate = new Date(start)
      startDateTime = startDate.getTime()
      let endDate = new Date(end)
      endDateTime = endDate.getTime()
      if (startDateTime > endDateTime) {
        let eventNumber = this.$store.state.error.sysErrorCode
          .sysErrorCode_650003
        let eventType = 9
        let reason = 'MSGCRD0091'
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.failureWord =
          this.sysErrorMsg.MSGCRD0091.name +
          this.sysErrorMsg.MSGCRD0091.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        this.showFailureModal = true
        this.showloadingModal = false
        return
      }

      if (message === '') {
        let eventNumber = this.$store.state.error.sysErrorCode
          .sysErrorCode_650003
        let reason = 'MSGCRD0092'
        let eventType = 9
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.failureWord =
          this.sysErrorMsg.MSGCRD0092.name +
          this.sysErrorMsg.MSGCRD0092.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        this.showFailureModal = true
      } else if (this.selectedTenantList.length === 0 && !this.selectAll) {
        let eventNumber = this.$store.state.error.sysErrorCode
          .sysErrorCode_650003
        let reason = 'MSGCRD0093'
        let eventType = 9
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.failureWord =
          this.sysErrorMsg.MSGCRD0093.name +
          this.sysErrorMsg.MSGCRD0093.value +
          'エラーコード：{' +
          eventNumber +
          '}'
        this.showFailureModal = true
      } else {
        this.$store.dispatch('maintenance/inputUpdate', {
          name: 'message',
          value: message
        })
        this.$store.dispatch('maintenance/inputUpdate', {
          name: 'startDateTime',
          value: startDateTime
        })
        this.$store.dispatch('maintenance/inputUpdate', {
          name: 'endDateTime',
          value: endDateTime
        })
        if (!this.selectAll) {
          this.$store.state.maintenance.selectAllFlag = false
        } else {
          this.$store.state.maintenance.selectAllFlag = true
        }
        this.$router.push('/master/maintenance/editConfirm')
      }
    },
    close() {
      this.showFailureModal = false
      if (this.toBackList) {
        this.$store.dispatch('maintenance/clearUpdateData')
        this.$store.dispatch('maintenance/clearSelectedTenantList')
        this.$router.push('/master/maintenance')
      }
    },
    createErrorMessage(error, eventNumber, errorNumber) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.header &&
        error.response.data.header.message
      ) {
        let errorMessage = error.response.data.header.message
        if (!errorMessage.indexOf('MSGCRD')) {
          this.failureWord =
            this.sysErrorMsg[errorMessage].name +
            this.sysErrorMsg[errorMessage].value +
            'エラーコード：{' +
            eventNumber +
            '}'
        } else {
          this.failureWord =
            this.sysErrorMsg[errorNumber].name +
            this.sysErrorMsg[errorNumber].value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
      } else {
        this.failureWord =
          this.sysErrorMsg.MSGCRD0001.name +
          this.sysErrorMsg.MSGCRD0001.value +
          'エラーコード：{' +
          eventNumber +
          '}'
      }
    }
  }
}
</script>
<style scoped>
.flex {
  display: flex;
  align-items: center;
}
.start_datepicker,
.end_datepicker {
  border: 2px solid #a6c6c5;
  border-radius: 3px;
  padding: 0 0 0 10px;
  height: 30px;
  font-size: 14px;
  width: calc(100% - 30px);
}
.bottom_button_area {
  display: flex;
  justify-content: end;
  margin: 100px 20px 20px 20px;
}
.control_bar {
  background-color: #bbffff;
}
.content,
.bottom {
  width: calc(100% - 262px);
  background-color: #ddffff;
}
.content_main {
  height: calc(100% - 110px);
  position: relative;
  background-color: #fff;
  padding: 26px 32px;
  overflow-y: scroll;
}
.control_bar {
  background-color: #bbffff;
}
.content_title {
  width: 100%;
  background-color: #ddffff;
}
.table_contents {
  table-layout: fixed;
  width: 30%;
}
.table_area {
  border: 1px solid #a6e3e0;
}
.bottom {
  height: 53px;
  width: 100%;
  border-top: none;
  background-color: #ddffff;
  position: sticky;
  bottom: auto;
}
.table_row_disabled {
  opacity: 0.5;
  pointer-events: none;
}
#maintenance_message {
  height: 37px;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/maintenance/maintenanceEdit.vue